/**
 * Client typé pour les routes `/journal` — Phase 4, incrément 4.10.1,
 * étendu **offline-first** en Phase 3.3.3.
 *
 * Première sub-entité coparenting. Pattern identique à messages
 * (4.8) : 3 méthodes, pas d'update (entrées immuables). Mutations
 * passent par `sendOrQueueMutation` (cf. 3.3.2).
 */
import { apiRequest } from './client.js';
import { sendOrQueueMutation, type SendResult } from './mutationsReplay.js';

export interface ApiJournalEntry {
  id: string;
  homeId: string;
  text: string;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateJournalEntryInput {
  text: string;
}

export async function listJournalEntries(homeId: string): Promise<ApiJournalEntry[]> {
  const data = await apiRequest<{ entries: ApiJournalEntry[] }>(`/homes/${homeId}/journal`);
  return data.entries;
}

export async function createJournalEntry(
  homeId: string,
  input: CreateJournalEntryInput,
  localId?: string,
): Promise<SendResult<{ entry: ApiJournalEntry }>> {
  return sendOrQueueMutation<{ entry: ApiJournalEntry }>({
    method: 'POST',
    path: `/homes/${homeId}/journal`,
    body: input,
    ...(localId ? { localId } : {}),
  });
}

export async function deleteJournalEntry(id: string): Promise<SendResult<void>> {
  return sendOrQueueMutation<void>({
    method: 'DELETE',
    path: `/journal/${id}`,
  });
}
